import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3" }
const _hoisted_2 = { class: "p-3 flex content-main gap-5 pb-[70px]" }
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = {
  key: 0,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pb-3"
}
const _hoisted_5 = { class: "flex justify-between h-[50px] items-center pt-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "flex gap-3 flex-col w-full items-start mb-3"
}
const _hoisted_8 = { class: "w-full lg:w-2/4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "w-full lg:w-2/4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "w-full lg:w-2/4" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "w-full lg:w-2/4" }
const _hoisted_18 = { class: "input-wrapper" }
const _hoisted_19 = { class: "w-full lg:w-2/4" }
const _hoisted_20 = {
  key: 0,
  class: "border-[1px] flex mt-[10px] bg-theme-orangefaded border-theme-orange rounded-[12px] text-white px-4 py-3 shadow-md",
  role: "alert"
}
const _hoisted_21 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5"
}
const _hoisted_22 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5"
}
const _hoisted_23 = { class: "p-4 text-[14px] rounded-lg" }
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg rounded py-4 px-4 pb-4" }
const _hoisted_26 = { class: "full flex" }
const _hoisted_27 = { class: "mt-3 mb-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_CustomDailogue = _resolveComponent("CustomDailogue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Nav),
        (_ctx.can_manage_compliance_settings)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.vg_selectedLocation.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "text-white font-semibold text-[24px]" }, "Compliance", -1)),
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            disabled: !_ctx.is_super_user,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!_ctx.is_super_user ? void(0) : _ctx.confirm()), ["prevent"])),
                            class: _normalizeClass((!_ctx.is_super_user ? 'bg-theme-grey text-slatewhite' : 'bg-white text-theme-green hover:bg-theme-darkgreen' ) + ' rounded  mt-2 px-4 py-2 ')
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("span", { class: "text-sm tracking-widest font-medium" }, "SAVE", -1)
                          ]))], 10, _hoisted_6))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", {
                              class: _normalizeClass('input-wrapper ' + (_ctx.form.providerName.error_type))
                            }, [
                              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-xs mb-1" }, "Choose a Regulatory Body", -1)),
                              _withDirectives(_createElementVNode("select", {
                                disabled: !_ctx.is_super_user,
                                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateFields(['providerName']))),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.providerName.value) = $event)),
                                class: _normalizeClass('block rounded border-none w-full text-sm text-theme-white ' + (!_ctx.is_super_user ? 'bg-theme-grey' : 'bg-gray-black'))
                              }, [...(_cache[14] || (_cache[14] = [
                                _createElementVNode("option", { value: "" }, "--Select--", -1),
                                _createElementVNode("option", { value: "ocs" }, "OCS", -1),
                                _createElementVNode("option", { value: "aglc" }, "AGLC", -1),
                                _createElementVNode("option", { value: "mbll" }, "MBLL", -1)
                              ]))], 42, _hoisted_9), [
                                [_vModelSelect, _ctx.form.providerName.value]
                              ]),
                              (_ctx.form.providerName.error_message)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "field-error label-text mt-1",
                                    textContent: _toDisplayString(_ctx.form.providerName.error_message)
                                  }, null, 8, _hoisted_10))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", {
                              class: _normalizeClass('input-wrapper ' + (_ctx.form.integrationSecret.error_type))
                            }, [
                              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-xs mb-1 font-normal" }, "Retailer Hash Key (to be confirmed)", -1)),
                              _withDirectives(_createElementVNode("input", {
                                disabled: !_ctx.is_super_user,
                                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['integrationSecret']))),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.integrationSecret.value) = $event)),
                                placeholder: "[Key example]",
                                type: "text",
                                class: _normalizeClass('block rounded border-none w-full text-sm text-theme-white ' + (!_ctx.is_super_user ? 'bg-theme-grey' : 'bg-gray-black'))
                              }, null, 42, _hoisted_12), [
                                [_vModelText, _ctx.form.integrationSecret.value]
                              ]),
                              (_ctx.form.integrationSecret.error_message)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "field-error label-text mt-1",
                                    textContent: _toDisplayString(_ctx.form.integrationSecret.error_message)
                                  }, null, 8, _hoisted_13))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", {
                              class: _normalizeClass('input-wrapper ' + (_ctx.form.integrationKey.error_type))
                            }, [
                              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-xs mb-1 font-normal" }, "CRSA", -1)),
                              _withDirectives(_createElementVNode("input", {
                                disabled: !_ctx.is_super_user,
                                onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateFields(['integrationKey']))),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.integrationKey.value) = $event)),
                                placeholder: "Enter here",
                                type: "text",
                                class: _normalizeClass('block rounded border-none w-full text-sm text-theme-white ' + (!_ctx.is_super_user ? 'bg-theme-grey' : 'bg-gray-black'))
                              }, null, 42, _hoisted_15), [
                                [_vModelText, _ctx.form.integrationKey.value]
                              ]),
                              (_ctx.form.integrationKey.error_message)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "field-error label-text mt-1",
                                    textContent: _toDisplayString(_ctx.form.integrationKey.error_message)
                                  }, null, 8, _hoisted_16))
                                : _createCommentVNode("", true),
                              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-theme-878686 text-xs mt-1" }, "License number of your retailer", -1))
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", {
                                class: "block text-white text-xs mb-2",
                                for: "company"
                              }, "Enable Compliance", -1)),
                              _createElementVNode("div", {
                                class: "flex items-center cursor-pointer",
                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (!_ctx.is_super_user ? void(0) : _ctx.form.complianceEnabled = !_ctx.form.complianceEnabled), ["prevent"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.complianceEnabled) = $event)),
                                  class: "hidden peer"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.form.complianceEnabled]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.complianceEnabled ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                                }, null, 2),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.complianceEnabled ? 'text-theme-green' : 'text-[#F53333]'])
                                }, _toDisplayString(_ctx.form.complianceEnabled ? 'On' : 'Off'), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (!_ctx.is_super_user)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[20] || (_cache[20] = [
                                  _createStaticVNode("<div class=\"flex\"><div><p class=\"font-semibold flex\"><svg width=\"20\" height=\"20\" class=\"mr-[10px]\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.325 11.175H10.825V4.85H9.325V11.175ZM10 15C10.2333 15 10.4292 14.9208 10.5875 14.7625C10.7458 14.6042 10.825 14.4083 10.825 14.175C10.825 13.9417 10.7458 13.7458 10.5875 13.5875C10.4292 13.4292 10.2333 13.35 10 13.35C9.76667 13.35 9.57083 13.4292 9.4125 13.5875C9.25417 13.7458 9.175 13.9417 9.175 14.175C9.175 14.4083 9.25417 14.6042 9.4125 14.7625C9.57083 14.9208 9.76667 15 10 15ZM10 20C8.58333 20 7.26667 19.7458 6.05 19.2375C4.83333 18.7292 3.775 18.025 2.875 17.125C1.975 16.225 1.27083 15.1667 0.7625 13.95C0.254167 12.7333 0 11.4167 0 10C0 8.6 0.254167 7.29167 0.7625 6.075C1.27083 4.85833 1.975 3.8 2.875 2.9C3.775 2 4.83333 1.29167 6.05 0.775C7.26667 0.258333 8.58333 0 10 0C11.4 0 12.7083 0.258333 13.925 0.775C15.1417 1.29167 16.2 2 17.1 2.9C18 3.8 18.7083 4.85833 19.225 6.075C19.7417 7.29167 20 8.6 20 10C20 11.4167 19.7417 12.7333 19.225 13.95C18.7083 15.1667 18 16.225 17.1 17.125C16.2 18.025 15.1417 18.7292 13.925 19.2375C12.7083 19.7458 11.4 20 10 20ZM10 18.5C12.3333 18.5 14.3333 17.6667 16 16C17.6667 14.3333 18.5 12.3333 18.5 10C18.5 7.66667 17.6667 5.66667 16 4C14.3333 2.33333 12.3333 1.5 10 1.5C7.66667 1.5 5.66667 2.33333 4 4C2.33333 5.66667 1.5 7.66667 1.5 10C1.5 12.3333 2.33333 14.3333 4 16C5.66667 17.6667 7.66667 18.5 10 18.5Z\" fill=\"#FCB852\"></path></svg><span class=\"text-sm\">You can&#39;t change your setting.</span></p><p class=\"text-sm mt-2\">Once saved, this information cannot be updated without going through our support.</p></div></div>", 1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("p", { class: "text-center text-theme-red mt-3" }, "Please select a location from the top left corner.", -1)
                  ]))]))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("p", { class: "text-center text-theme-red mt-3" }, "Page is restricted.", -1)
            ]))]))
      ])
    ]),
    (_ctx.confirmModal.modal)
      ? (_openBlock(), _createBlock(_component_CustomDailogue, {
          key: 0,
          size: "max-w-3xl"
        }, {
          maincontent: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "text-2xl text-white text-center pr-[40px]" }, "Caution!", -1)),
                _createElementVNode("span", {
                  class: "absolute right-1 top-1 pointer cursor-pointer hover:opacity-60",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"]))
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z",
                      fill: "white"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "full justify-content-center" }, [
                  _createElementVNode("div", {
                    class: "border-[1px] bg-theme-orangefaded border-theme-orange rounded-[12px] text-white px-4 py-3 shadow-md",
                    role: "alert"
                  }, [
                    _createElementVNode("div", { class: "flex" }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "font-semibold flex" }, [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            class: "mr-[10px]",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M9.325 11.175H10.825V4.85H9.325V11.175ZM10 15C10.2333 15 10.4292 14.9208 10.5875 14.7625C10.7458 14.6042 10.825 14.4083 10.825 14.175C10.825 13.9417 10.7458 13.7458 10.5875 13.5875C10.4292 13.4292 10.2333 13.35 10 13.35C9.76667 13.35 9.57083 13.4292 9.4125 13.5875C9.25417 13.7458 9.175 13.9417 9.175 14.175C9.175 14.4083 9.25417 14.6042 9.4125 14.7625C9.57083 14.9208 9.76667 15 10 15ZM10 20C8.58333 20 7.26667 19.7458 6.05 19.2375C4.83333 18.7292 3.775 18.025 2.875 17.125C1.975 16.225 1.27083 15.1667 0.7625 13.95C0.254167 12.7333 0 11.4167 0 10C0 8.6 0.254167 7.29167 0.7625 6.075C1.27083 4.85833 1.975 3.8 2.875 2.9C3.775 2 4.83333 1.29167 6.05 0.775C7.26667 0.258333 8.58333 0 10 0C11.4 0 12.7083 0.258333 13.925 0.775C15.1417 1.29167 16.2 2 17.1 2.9C18 3.8 18.7083 4.85833 19.225 6.075C19.7417 7.29167 20 8.6 20 10C20 11.4167 19.7417 12.7333 19.225 13.95C18.7083 15.1667 18 16.225 17.1 17.125C16.2 18.025 15.1417 18.7292 13.925 19.2375C12.7083 19.7458 11.4 20 10 20ZM10 18.5C12.3333 18.5 14.3333 17.6667 16 16C17.6667 14.3333 18.5 12.3333 18.5 10C18.5 7.66667 17.6667 5.66667 16 4C14.3333 2.33333 12.3333 1.5 10 1.5C7.66667 1.5 5.66667 2.33333 4 4C2.33333 5.66667 1.5 7.66667 1.5 10C1.5 12.3333 2.33333 14.3333 4 16C5.66667 17.6667 7.66667 18.5 10 18.5Z",
                              fill: "#FCB852"
                            })
                          ]),
                          _createElementVNode("span", { class: "text-base" }, "This is a final action that can’t be undone")
                        ]),
                        _createElementVNode("p", { class: "text-sm mt-2" }, "Once saved, this information cannot be updated without going through our support.")
                      ])
                    ])
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                    class: "text-base tracking-wide uppercase text-white bg-theme-green hover:bg-theme-darkgreen w-2/3 mt-6 border-0 rounded-md p-2 block mx-auto"
                  }, "CONFIRM TO PROCEED")
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"])),
                  class: "text-white tracking-wide hover:text-theme-green text-center"
                }, "CLOSE")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}